module.exports = __webpack_public_path__ + "static/media/569JamesPBrawleyDrNW_2018-06-12_105.b81a810b.jpg";